const CHECKOUT_SELECTOR = 'button[name="checkout"], #checkout, a[href*="/checkout"]';

let checkoutClickTracked = false;

function checkoutDetail(target) {
  return {
    source: 'checkout_click',
    button_id: target?.id || '',
    button_name: target?.getAttribute?.('name') || '',
    page_location: window.location.href,
    page_title: document.title,
    value_cents: Number(target?.dataset?.cartTotalCents) || undefined,
    currency: target?.dataset?.currency || window.Shopify?.currency?.active || undefined,
    item_count: Number(target?.dataset?.cartItemCount) || undefined,
  };
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target.closest(CHECKOUT_SELECTOR);
    if (!target || checkoutClickTracked || target.disabled) return;

    checkoutClickTracked = true;

    window.LoraClickIdTracking?.syncCartAttributes?.({ keepalive: true });
    window.Shopify?.analytics?.publish?.('lora_checkout_click', checkoutDetail(target));
  },
  true
);
